import { render } from "./order.vue?vue&type=template&id=390fc352&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=390fc352&lang=scss&scoped=true"

import exportComponent from "E:\\Work\\TEHNOLAND\\megamarketAdmin\\adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390fc352"]])

export default __exports__